import React, { useEffect, useMemo, useState } from 'react';
import { get } from '@/security/Axios';

function resolveCompanyId() {
  try {
    const params = new URLSearchParams(window.location.search || '');
    return (
      (params.get('company_id') || params.get('company') || '').trim() ||
      (localStorage.getItem('company_id') || '').trim() ||
      ''
    );
  } catch {
    return '';
  }
}

function formatResetAt(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString();
}

export default function DemoWorkspaceBanner() {
  const [status, setStatus] = useState(null);
  const [companyId, setCompanyId] = useState(() => resolveCompanyId());

  useEffect(() => {
    const syncCompany = () => setCompanyId(resolveCompanyId());

    syncCompany();
    window.addEventListener('popstate', syncCompany);
    window.addEventListener('hashchange', syncCompany);

    const interval = window.setInterval(syncCompany, 1500);
    return () => {
      window.removeEventListener('popstate', syncCompany);
      window.removeEventListener('hashchange', syncCompany);
      window.clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await get('/demo/public-status', {
          params: companyId ? { company_id: companyId } : undefined,
        });
        if (!cancelled) setStatus(res?.data || null);
      } catch {
        if (!cancelled) setStatus(null);
      }
    }

    load();
    const interval = window.setInterval(load, 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [companyId]);

  const message = useMemo(() => {
    if (!status?.isDemoCompany) return '';
    if (status?.enabled === false) {
      return 'This demo is currently disabled.';
    }
    return (
      status?.warningMessage ||
      'Demo workspace: changes made here are temporary and are automatically deleted within 24 hours.'
    );
  }, [status]);

  if (!status?.isDemoCompany || !message) return null;

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        width: '100%',
        background: 'linear-gradient(90deg, #fff3cd 0%, #ffe8a3 100%)',
        color: '#5c4400',
        borderBottom: '1px solid rgba(92, 68, 0, 0.18)',
        boxShadow: '0 6px 24px rgba(92, 68, 0, 0.08)',
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '10px 16px',
          fontSize: 14,
          fontWeight: 600,
          display: 'flex',
          gap: 12,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <span>{message}</span>
        {status?.nextResetAt ? (
          <span style={{ fontWeight: 500 }}>
            Next reset: {formatResetAt(status.nextResetAt)}
          </span>
        ) : null}
      </div>
    </div>
  );
}
